import axios from 'axios';
import { req,reqObj } from './axiosFun';
import { downLoadReq }  from "./downLoad"
//通过类型获取所有相关配置选项
export const getConfigBytype = (params) => { return req("get", "/api/terminalInfo/getConfigurationListByType", params) };

//添加水电价格配置
export const addPriceConfig = (params) => { return req("post", "/api/priceConfig/addPriceConfig", params) };

//水电价格列表
export const getPriceConfigList = (params) => { return req("get", "/api/priceConfig/getPriceConfigList", params) };

//添加水电价格配置
export const deletePriceConfig = (params) => { return req("post", "/api/priceConfig/deletePriceConfig", params) };

//修改水电价格配置
export const updatePriceConfig = (params) => { return req("post", "/api/priceConfig/updatePriceConfig", params) };

//水电价格列表
// export const getPriceConfigList = (params) => { return req("get", "/api/priceConfig/getPriceConfigList", params) };




//获取所有的计量点信息
export const findAllMeterInfoList = (params) => { return req("get", "/api/meterInfo/findAllMeterInfoList", params) };

export const findAllMeterInfoListByPriceId = (params) => { return req("get", "/api/meterInfo/findAllMeterInfoListByPriceId", params) };


export const findAllMeterInfoByInverPriceIds = (params) => { return req("get", "/api/meterInfo/findAllMeterInfoByInverPriceIds", params) };


//电价绑定
export const priceBindMeterinfo = (params) => { return req("post", "/api/priceConfig/priceBindMeterinfo", params) };

//终端用户添加
export const appletUserAdd = (params) => { return req("post", "/api/appletUser/appletUserAdd", params) };


//获取所有房间
export const getRoomAllList = (params) => { return req("get", "/api/room/getRoomAllList", params) };

//获取所有终端用户
export const appletUserList = (params) => { return req("get", "/api/appletUser/appletUserList", params) };


//开户管理获取所有终端用户
export const openAccountGetAppletUserList = (params) => { return req("get", "/api/appletUser/openAccountGetAppletUserList", params) };



//终端用户添加
export const appletUserDelete = (params) => { return req("post", "/api/appletUser/appletUserDelete", params) };

//终端用户修改
export const appletUserUpdate = (params) => { return req("post", "/api/appletUser/appletUserUpdate", params) };

//充值
export const recharge = (params) => { return req("post", "/api/account/recharge", params) };

//退费
export const refund = (params) => { return req("post", "/api/account/refund", params) };



//检查计量点是否已经绑定了价格
export const checkPriceBindMeterinfo = (params) => { return req("post", "/api/priceConfig/checkPriceBindMeterinfo", params) };


//获取充值记录
export const getAccountDetail = (params) => { return req("get", "/api/account/getAccountDetail", params) };


export const getAccountHistory = (params) => { return req("get", "/api/account/getAccountHistory", params) };


//导入用户
export const uploadAppletUser = (params) => { return req("post", "/api/appletUser/uploadAppletUser", params,true) };


//远程拉合闸
export const remoteDisconnect = (params) => { return req("post", "/api/meterInfo/remoteDisconnect", params) };


//查询信息
export const sendMeterInfoMsg = (params) => { return req("get", "/api/meterInfo/sendMeterInfoMsg", params) };

//获取没有绑定的计量点信息
export const findMybdMeterInfoList = (params) => { return req("get", "/api/meterInfo/findMybdMeterInfoList", params) };

//终端用户导出
export const poiAppletUserList = (params) => { return downLoadReq("get","/api/appletUser/poiAppletUserList", params) };


export const findRoomAccountList = (params) => { return req("get", "/api/roomAccount/findRoomAccountList", params) };

export const getPropertyPriceConfigList = (params) => { return req("get", "/api/propertyPriceConfig/getPropertyPriceConfigList", params) };

export const addPropertyPriceConfig = (params) => { return req("post", "/api/propertyPriceConfig/addPropertyPriceConfig", params) };

export const deletePropertyPriceConfig = (params) => { return req("post", "/api/propertyPriceConfig/deletePropertyPriceConfig", params) };

export const updatePropertyPriceConfig = (params) => { return req("post", "/api/propertyPriceConfig/updatePropertyPriceConfig", params) };


export const findAllRoomList = (params) => { return req("get", "/api/room/findRoomList", params) };

export const addRoom = (params) => { return req("post", "/api/room/addRoom", params) };

export const deleteRoom = (params) => { return req("post", "/api/room/deleteRoom", params) };

export const updateRoom = (params) => { return req("post", "/api/room/modifyRoom", params) };

export const notRoomName = (params) => { return req("get", "/api/room/notRoomName", params) };

export const priceBindRoom = (params) => { return req("post", "/api/propertyPriceConfig/priceBindRoom", params) };

export const checkPriceBindRoom = (params) => { return req("post", "/api/propertyPriceConfig/checkPriceBindRoom", params) };

export const roomRecharge = (params) => { return req("post", "/api/roomAccount/roomRecharge", params) };

export const roomRefund = (params) => { return req("post", "/api/roomAccount/roomRefund", params) };

export const addWaterMeter = (params) => { return req("post", "/api/waterMeter/addWaterMeter", params) };

export const findWaterMeterList = (params) => { return req("get", "/api/waterMeter/findWaterMeterList", params) };

export const modifyWaterMeter = (params) => { return req("post", "/api/waterMeter/modifyWaterMeter", params) };

export const removeWaterMeter = (params) => { return req("post", "/api/waterMeter/removeWaterMeter", params) };

export const uploadWaterMeter = (params) => { return req("post", "/api/waterMeter/uploadWaterMeter", params,true) };

export const generateWaterAndPropertyMonthlyBill = (params) => { return downLoadReq("get","/api/propertyPriceConfig/generateWaterAndPropertyMonthlyBill", params) };

export const findMeterInfoByDepartmentId = (params) => { return req("get", "/api/room/findMeterInfoByDepartmentId", params,true) };

export const saveOrModifyJfpgPrice = (params) => { return req("post", "/api/jfpgPrice/saveOrModifyJfpgPrice", params) };

export const findJfpgPrices = (params) => { return req("get", "/api/jfpgPrice/findJfpgPrices", params) };


export const removeJfpgPrice = (params) => { return req("post", "/api/jfpgPrice/removeJfpgPrice", params) };

export const saveMeterInfoPrice = (params) => { return req("post", "/api/jfpgPrice/saveMeterInfoPrice", params) };

export const findMeterInfosByPirceId = (params) => { return req("get", "/api/jfpgPrice/findMeterInfosByPirceId", params) };

export const findMeterInfosByTerminalId = (params) => { return req("get", "/api/jfpgPrice/findMeterInfosByTerminalId", params) };


export const unitAdd = (params) => { return req("post", "/api/unit/unitAdd", params) };

export const getUnitList = (params) => { return req("get", "/api/unit/getUnitList", params) };

export const unitDelete = (params) => { return req("post", "/api/unit/unitDelete", params) };

export const unitUpdate = (params) => { return req("post", "/api/unit/unitUpdate", params) };

export const findRoomContractList = (params) => { return req("get", "/api/roomContract/findRoomContractList", params) };

export const roomRentAdd = (params) => { return req("post", "/api/roomRent/roomRentAdd", params) };

export const getRoomRentList = (params) => { return req("get", "/api/roomRent/getRoomRentList", params) };

export const roomRentDelete = (params) => { return req("post", "/api/roomRent/roomRentDelete", params) };

export const roomRentUpdate = (params) => { return req("post", "/api/roomRent/roomRentUpdate", params) };

export const saveAndModifyRoomContract = (params) => { return req("post", "/api/roomContract/saveAndModifyRoomContract", params) };

export const removeRoomContract = (params) => { return req("post", "/api/roomContract/removeRoomContract", params) };

export const saveAndModifyConfig = (params) => { return req("post", "/api/roomBillConfig/saveAndModifyConfig", params) };

export const findRoomConfig = (params) => { return req("get", "/api/roomBillConfig/findRoomConfig", params) };


export const removeConfig = (params) => { return req("post", "/api/roomBillConfig/removeConfig", params) };

export const findRoomMonthBillList = (params) => { return req("get","/api/roomMonthBill/findRoomMonthBillList", params) };

export const toListNew = (params) => { return req("post","/api/roomContract/toListNew", params) };


export const modifyRoomMonthBill = (params) => { return req("post","/api/roomMonthBill/modifyRoomMonthBill", params) };

export const findMeterInfoPower = (params) => { return req("get","/api/appletUser/findMeterInfoPower", params) };

export const saveAccount = (params) => { return req("post","/api/appletUser/saveAccount", params) };

export const addRentRoom = (params) => { return req("post","/api/rentRoom/addRentRoom", params) };

export const deleteRentRoom = (params) => { return req("post","/api/rentRoom/deleteRentRoom", params) };

export const findRentRoomList = (params) => { return req("get","/api/rentRoom/findRentRoomList", params) };

export const modifyRentRoom = (params) => { return req("post","/api/rentRoom/modifyRentRoom", params) };

export const walletAdd = (params) => { return req("post","/api/wallet/walletAdd", params) };

export const walletSelectByDptId = (params) => { return req("get","/api/wallet/walletSelectByDptId", params) };
export const walletSelectByDptId2 = (params) => { return req("get","/api/wallet/walletSelectByDptId2", params) };

export const userBindWallet = (params) => { return req("post","/api/wallet/userBindWallet", params) };

export const findUsersById = (params) => { return req("get","/api/wallet/findUsersById", params) };

export const findAppletUserBindingWallet = (params) => { return req("get","/api/wallet/findAppletUserBindingWallet", params) };

export const findMeterInfoBindingWallet = (params) => { return req("get","/api/wallet/findMeterInfoBindingWallet", params) };

export const MeterInfoBindingWallet = (params) => { return req("post","/api/wallet/MeterInfoBindingWallet", params) };

export const findMeterInfosById = (params) => { return req("get","/api/wallet/findMeterInfosById", params) };


export const invest = (params) => { return req("post","/api/wallet/invest", params) };

export const deduction = (params) => { return req("post","/api/wallet/deduction", params) };

export const walletUpdate = (params) => { return req("post","/api/wallet/walletUpdate", params) };

export const FindRechargesAndPage = (params) => { return req("get","/api/recharge/findRechargesAndPage", params) };

//根据租户获取部门
export const findAppletUserDepartment = (params) => { return req("get","/api/appletUser/findAppletUserDepartment", params) };

export const findMeterBlanceAndEnergyType = (params) => { return req("get","/api/account/findMeterBlanceAndEnergyType", params) };

//钱包交易记录导出
export const exportRecharges = (params) => { return downLoadReq("get","/api/recharge/exportRecharges", params) };


export const getWalletBill = (params) => { return req("get","/api/walletbill/getWalletBill", params) };

export const findMeterReadingTotalByDepId = (params) => { return req("get","/api/meterReadingTotal/findMeterReadingTotalByDepId", params) };


export const getWalletBillPoiFiter = (params) => { return downLoadReq("get","/api/walletbill/getWalletBillPoiFiter", params) };


//添加拉闸时间点规则
export const add_meter_cut_instant_rule = (params) => { return reqObj("/api/meter_reading_cost/add_meter_cut_instant_rule", params) };

//拉闸时间点规则列表
export const list_meter_cut_instant_rule = (params) => { return req( 'get', "/api/meter_reading_cost/list_meter_cut_instant_rule", params) };

//修改拉闸时间点规则
export const update_meter_cut_instant_rule = (params) => { return reqObj("/api/meter_reading_cost/update_meter_cut_instant_rule", params) };


//删除拉闸时间点规则
export const del_meter_cut_instant_rule = (params) => { return req('post',"/api/meter_reading_cost/del_meter_cut_instant_rule", params) };

//拉闸时间点规则绑定钱包
export const meter_cut_instant_rule_bind_wallet = (params) => { return reqObj("/api/meter_reading_cost/meter_cut_instant_rule_bind_wallet", params) };

//拉闸时间点规则绑定钱包
export const mmeter_cut_instant_rule_bind_wallet = (params) => { return reqObj("/api/single_meter_reading_cost/meter_cut_instant_rule_bind_wallet", params) };





//拉闸时间点规则解绑钱包
export const meter_cut_instant_rule_unbind_wallet = (params) => { return reqObj("/api/meter_reading_cost/meter_cut_instant_rule_unbind_wallet", params) };


//拉闸时间点规则解绑计量点
export const mmeter_cut_instant_rule_unbind_wallet = (params) => { return reqObj("/api/single_meter_reading_cost/meter_cut_instant_rule_unbind_wallet", params) };


//添加拉闸阈值规则
export const add_meter_cut_threshold_rule = (params) => { return reqObj("/api/meter_reading_cost/add_meter_cut_threshold_rule", params) };

//拉闸时间点规则列表
export const list_meter_cut_threshold_rule = (params) => { return req( 'get', "/api/meter_reading_cost/list_meter_cut_threshold_rule", params) };

//删除拉闸时间点规则
export const del_meter_cut_threshold_rule = (params) => { return req('post',"/api/meter_reading_cost/del_meter_cut_threshold_rule", params) };
//修改拉闸时间点规则
export const update_meter_cut_threshold_rule = (params) => { return reqObj("/api/meter_reading_cost/update_meter_cut_threshold_rule", params) };

//拉闸阈值规则绑定钱包
export const meter_threshold_instant_rule_bind_wallet = (params) => { return reqObj("/api/meter_reading_cost/meter_threshold_instant_rule_bind_wallet", params) };

//拉闸阈值规则绑定计量点
export const mmeter_threshold_instant_rule_bind_wallet = (params) => { return reqObj("/api/single_meter_reading_cost/meter_threshold_instant_rule_bind_wallet", params) };



//拉闸阈值规则解绑钱包
export const meter_threshold_instant_rule_unbind_wallet = (params) => { return reqObj("/api/meter_reading_cost/meter_threshold_instant_rule_unbind_wallet", params) };

//拉闸阈值规则解绑计量点
export const mmeter_threshold_instant_rule_unbind_wallet = (params) => { return reqObj("/api/single_meter_reading_cost/meter_threshold_instant_rule_unbind_wallet", params) };



//添加抄表时间点规则
export const add_meter_recording_rule = (params) => { return reqObj("/api/meter_reading_cost/add_meter_recording_rule", params) };


//修改抄表时间点规则
export const update_meter_recording_rule = (params) => { return req( 'get', "/api/meter_reading_cost/update_meter_recording_rule", params) };

//抄表时间点规则列表
export const list_meter_recording_rule = (params) => { return req( 'get', "/api/meter_reading_cost/list_meter_recording_rule", params) };

//删除抄表时间点规则
export const del_meter_recording_rule = (params) => { return req('post',"/api/meter_reading_cost/del_meter_recording_rule", params) };

//抄表时间点规则绑定钱包
export const meter_recording_rule_bind_wallet = (params) => { return reqObj("/api/meter_reading_cost/meter_recording_rule_bind_wallet", params) };

//抄表时间点规则绑定计量点
export const mmeter_recording_rule_bind_wallet = (params) => { return reqObj("/api/single_meter_reading_cost/meter_recording_rule_bind_wallet", params) };


//抄表时间点规则解绑钱包
export const meter_recording_rule_unbind_wallet = (params) => { return reqObj("/api/meter_reading_cost/meter_recording_rule_unbind_wallet", params) };

//抄表时间点规则解绑计量点
export const mmeter_recording_rule_unbind_wallet = (params) => { return reqObj("/api/single_meter_reading_cost/meter_recording_rule_unbind_wallet", params) };


//根据规则获取钱包列表
export const list_wallet_by_rule = (params) => { return req( 'get', "/api/meter_reading_cost/list_wallet_by_rule", params) };

//抄表时间点规则列表
//export const list_prepaid_department_by_pay_type = (params) => { return req( 'get', "/api/meter_reading_cost/list_prepaid_department_by_pay_type", params) };
export const list_prepaid_department = (params) => { return req( 'get', "/api/meter_reading_cost/list_prepaid_department", params) };



export const walletSelectByCondition = (params) => { return reqObj("/api/wallet/walletSelectByCondition", params) };

export const findRechargesPageCondition = (params) => { return reqObj("/api/recharge/findRechargesPageCondition", params) };


//添加欠费提醒短信规则
export const add_sms_arrear_notify_rule = (params) => { return reqObj("/api/sms_rule/add_sms_arrear_notify_rule", params) };

//欠费提醒短信规则列表
export const list_sms_arrear_notify_rule = (params) => { return req("get","/api/sms_rule/list_sms_arrear_notify_rule", params) };

//删除欠费提醒短信规则
export const del_sms_arrear_notify_rule = (params) => { return req('post',"/api/sms_rule/del_sms_arrear_notify_rule", params) };


//修改欠费提醒短信规则
export const update_sms_arrear_notify_rule = (params) => { return reqObj(  "/api/sms_rule/update_sms_arrear_notify_rule", params) };


//添加余额提醒短信规则
export const add_sms_balance_notify_rule = (params) => { return reqObj("/api/sms_rule/add_sms_balance_notify_rule", params) };

//余额提醒短信规则列表
export const list_sms_balance_notify_rule = (params) => { return req("get","/api/sms_rule/list_sms_balance_notify_rule", params) };

//删除余额提醒短信规则
export const del_sms_balance_notify_rule = (params) => { return req('post',"/api/sms_rule/del_sms_balance_notify_rule", params) };

//修改欠费提醒短信规则
export const update_sms_balance_notify_rule = (params) => { return reqObj(  "/api/sms_rule/update_sms_balance_notify_rule", params) };


export const alist_wallet_by_rule = (params) => { return req("get","/api/sms_rule/list_wallet_by_rule", params) };

//欠费提醒短信规则绑定钱包
export const sms_arrear_notify_rule_bind_wallet = (params) => { return reqObj("/api/sms_rule/sms_arrear_notify_rule_bind_wallet", params) };


//欠费提醒短信规则绑定钱包
export const sms_balance_notify_rule_bind_wallet = (params) => { return reqObj("/api/sms_rule/sms_balance_notify_rule_bind_wallet", params) };

//欠费提醒短信规则解绑钱包
export const sms_arrear_notify_rule_unbind_wallet = (params) => { return reqObj("/api/sms_rule/sms_arrear_notify_rule_unbind_wallet", params) };


//余额提醒短信规则解绑钱包
export const sms_balance_notify_rule_unbind_wallet = (params) => { return reqObj("/api/sms_rule/sms_balance_notify_rule_unbind_wallet", params) };


// 根据规则获取计量点列表( 用户欠费短信 )
export const mlist_meter_info_by_rule = (params) => { return req("get","/api/single_meter_sms_rule/list_meter_info_by_rule", params) };

//根据规则获取计量点列表 ( 拉闸-抄表-扣费 )
export const list_meter_info_by_rule = (params) => { return req("get","/api/single_meter_reading_cost/list_meter_info_by_rule", params) };


//欠费提醒规则绑定计量点
export const sms_arrear_notify_rule_bind_single_meter = (params) => { return reqObj("/api/single_meter_sms_rule/sms_arrear_notify_rule_bind_single_meter", params) };

//余额提醒短信规则绑定计量点
export const sms_balance_notify_bind_single_meter = (params) => { return reqObj("/api/single_meter_sms_rule/sms_balance_notify_bind_single_meter", params) };



//欠费提醒短信规则解计量点
export const sms_arrear_notify_rule_unbind_single_meter = (params) => { return reqObj("/api/single_meter_sms_rule/sms_arrear_notify_rule_unbind_single_meter", params) };

//余额提醒短信规则解绑计量点
export const sms_balance_notify_unbind_single_meter = (params) => { return reqObj("/api/single_meter_sms_rule/sms_balance_notify_unbind_single_meter", params) };

//添加或者修改银行账号
export const saveOrUpdateBankAccount = (params) => { return req('post', "/api/bankAccount/saveOrUpdateBankAccount", params) };

//添加或者修改银行账号
export const findBankAccountList = (params) => { return req('get', "/api/bankAccount/findBankAccountList", params) };

//删除银行账号
export const BankAccountDelete = (params) => { return req('post', "/api/bankAccount/BankAccountDelete", params) };


//根据部门id获取计量点
export const findMeterIdByDeptId = (params) => { return req('get', "/api/bankAccount/findMeterIdByDeptId", params) };
//根据部门id获取计量点
export const findMeterIdByBankId = (params) => { return req('get', "/api/bankAccount/findMeterIdByBankId", params) };

//绑定账号计量点
export const addBankAccountMeterInfo = (params) => { return req('post', "/api/bankAccount/addBankAccountMeterInfo", params) };


//解绑账号计量点
export const removeBankAccountMeterInfo = (params) => { return req('post', "/api/bankAccount/removeBankAccountMeterInfo", params) };


export const addInverseRule = (params) => { return req('post', "/api/inverseRule/addInverseRule", params) };


export const getInverseRules = (params) => { return req('get', "/api/inverseRule/getInverseRules", params) };

export const checkPriceBindMeterInfo = (params) => { return req('post', "/api/inverseRule/checkPriceBindMeterInfo", params) };

export const priceBindMeterInfo = (params) => { return req('post', "/api/inverseRule/priceBindMeterInfo", params) };

export const updateInverseRule = (params) => { return req('post', "/api/inverseRule/updateInverseRule", params) };

export const deleteInverseRule = (params) => { return req('post', "/api/inverseRule/deleteInverseRule", params) };


export const findBalDataList = (params) => { return req('get', "/api/newMonthBillData/findBalDataList", params) };

export const addBalanceData = (params) => { return req('post', "/api/newMonthBillData/addBalanceData", params) };



// WEBPACK FOOTER //
// ./src/api/payMG.js